import React from 'react';
import { ProjectId } from '../../../models/Types';
import { makePrioStyles } from '../../../theme/utils';
import Flex from '../../../components/Flex';
import { useTheme } from 'react-jss';
import { PrioTheme } from '../../../theme/types';
import ProjectDocumentTagsManagement from './ProjectDocumentTagsManagement';
import SingleStringSettingManagement from './SingleStringSettingManagement';
import { apiFetchDocumentProjectSettingPreview } from '../../mail/api';
import { useTranslation } from 'react-i18next';

const useStyles = makePrioStyles((theme) => ({
  root: {
    backgroundColor: theme.old.palette.backgroundPalette.sub,
    padding: theme.old.spacing.defaultPadding,
    height: '100%',
    overflowY: 'auto',
  },
  shadow: {
    boxShadow: theme.old.palette.boxShadow.regular,
  },
}));

interface DocumentSettingsPageProps {
  projectId: ProjectId;
}

export const DocumentSettingsPage: React.FC<DocumentSettingsPageProps> = (
  props
) => {
  const classes = useStyles();
  const theme = useTheme<PrioTheme>();
  const { t } = useTranslation();
  const { projectId } = props;

  const fetchProjectDocumentPrefix = async () => {
    const { data } = await apiFetchDocumentProjectSettingPreview(projectId, [
      'projectDocumentPrefix',
    ]);
    return data?.['projectDocumentPrefix'] ?? null;
  };

  return (
    <div className={classes.root}>
      <Flex.Column childrenGap={theme.old.spacing.unit(2)}>
        <SingleStringSettingManagement
          className={classes.shadow}
          projectId={projectId}
          settingKey="Document_Prefix"
          settingType="projectDocumentPrefix"
          title={t(
            'projects:projectDocumentSettingsManagement.labels.projectDocumentPrefix'
          )}
          addNewLabel={t(
            'projects:projectDocumentSettingsManagement.addNewPrefix'
          )}
          newValuePlaceholder={t(
            'projects:projectDocumentSettingsManagement.newPrefixPlaceholder'
          )}
          resolvedPreviewFn={fetchProjectDocumentPrefix}
        />
        <ProjectDocumentTagsManagement
          className={classes.shadow}
          projectId={projectId}
        />
      </Flex.Column>
    </div>
  );
};

export default DocumentSettingsPage;
